module.exports = __webpack_public_path__ + "connect_icon.69c04bebe47714843803.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/connect_icon.svg
// module id = 1405
// module chunks = 3